import InviteCnt from "../common/InviteCnt";
import { translations } from "../common/i18n";

import { Component, createSignal } from 'solid-js';
import "./style.scss"

const App: Component = () => {
    const t = translations[window.lang ?? "ro"];
    const [getCode, setCode] = createSignal<string>("");

    const onSubmit = (event: SubmitEvent) => {
        event.preventDefault();
        window.location.assign(`/${window.lang}/c/${getCode().toUpperCase()}`);
    };

    const errorCode = window.location.search.includes("error=1") ? 1 : window.location.search.includes("error=2") ? 2 : 0;

    return (
        <div class="w-full min-h-screen flex justify-center items-center">
            <InviteCnt>
                <form onSubmit={onSubmit} class="flex flex-col justify-center items-center gap-2">
                    <div class="text-center">{t.enterCode}</div>
                    <div>
                        <input
                            type="text"
                            placeholder={t.codePlaceholder}
                            class="input text-center"
                            value={getCode().toUpperCase()}
                            onChange={(event) => {
                                setCode(event.target.value);
                            }}
                        />
                    </div>
                    <div><button type="submit" class="btn">{t.submit}</button></div>
                    { errorCode !== 0 && <div class="bg-red-500 text-white p-2">{ errorCode === 1 ? t.errorBadCode : t.errorWrongCode }</div> }
                </form>
            </InviteCnt>
        </div>
    );
};

export default App;